// @flow
import type {Element} from 'react'
import React from 'react'

import Attribute from './Attribute'
import ItalicizedTitle from './ItalicizedTitle'
import List from './List'
import MinorList from './MinorList'
import Note from './Note'
import styles from './index.scss'

export type Summary = $ReadOnly<{
  sections: $ReadOnly<any>,
  ...,
}>

type Props = $ReadOnly<{
  summary: Summary,
}>

const sectionSupportMap = {
  attribute: Attribute,
  italicized_title: ItalicizedTitle,
  list: List,
  minor_list: MinorList,
  note: Note,
}

function renderSection(section: any) {
  const key = JSON.stringify(section)
  const SectionComponent = sectionSupportMap[section.type]

  if (!SectionComponent)
    return null

  return (
    <SectionComponent
      key={key}
      section={section}
    />
  )
}

function ProposalChangeSummary({summary}: Props): Element<"div"> {
  const {sections} = summary
  const sectionsToRender = sections.filter((section) => section.type !== 'italicized_title')

  return (
    <div className={styles.summary}>
      {sections.length
        ? sectionsToRender.map(renderSection)
        : I18n.t('proposal.sentences.no_changes_yet2')
      }
    </div>
  )
}

export default ProposalChangeSummary
